import GestantesIcon from '@/components/icons/IndicadoresAps/PreNatal/ConsultasPreNatal.vue'

export default {
  value: 'b7',
  label: 'Gestantes',
  iconType: 'component',
  iconComponent: GestantesIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: 'Gestante ainda não tem atendimento odontológico.',
  },
}
